import React, { useCallback } from 'react'
import { observer } from 'mobx-react'

import useInject from "~/hooks/useInject"
import DisplayInputContainer from './DisplayInputContainer'
import SimpleInput from '~/components/Form/SimpleInput'

const mapStore = store => ({
  user: store.auth.user
})

const FullName = props => {
  const { user } = useInject(mapStore)
  const { isEditing } = props
  const userFullNameError = user.validateDisplayMessage('name')

  const handleChange = useCallback(targetKey => event => {
    const input = event.target.value
    user.changeKey(targetKey, input)
  }, [user])

  return (
    <DisplayInputContainer
      value={user.name}
      isEditing={isEditing}
      label="Full Name"
      error={userFullNameError}
    >
      <SimpleInput 
        id="fullName"
        name="fullName"
        value={user.name}
        onChange={handleChange('name')}
        error={userFullNameError}
      />
    </DisplayInputContainer>
  )
}

export default observer(FullName)